import { render, staticRenderFns } from "./powerpoint.vue?vue&type=template&id=06b26f63&scoped=true&"
import script from "./powerpoint.vue?vue&type=script&lang=js&"
export * from "./powerpoint.vue?vue&type=script&lang=js&"
import style0 from "./powerpoint.vue?vue&type=style&index=0&id=06b26f63&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b26f63",
  null
  
)

export default component.exports